export const labelRenameRoutes = [
    {
        path: '',
        name: 'LabelRename',
        exact: true,
        component: () => import('../views/LabelRenameIndex.vue'),
        meta: {
            breadcrumb: [{ label: 'Label Rename' }],
        },
    },
];
